import Immutable from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { Comment, CommentMap } from 'records/Comment';
import {
  addComment,
  commentsForIssue,
  deleteComment,
  editComment,
} from 'services/commentService';

export interface CommentActions {
  getCommentsForIssue: (
    ActionParams: AppStateActionParams,
    issueid: string
  ) => Promise<AppState>;

  addComment: (
    ActionParams: AppStateActionParams,
    issueid: string,
    projectid: string,
    comment: string,
    date: number
  ) => Promise<AppState>;

  deleteComment: (
    ActionParams: AppStateActionParams,
    commentid: string,
    issueid: string,
    projectid: string,
    date: number
  ) => Promise<AppState>;

  editComment: (
    ActionParams: AppStateActionParams,
    issueid: string,
    projectid: string,
    comment: string,
    commentid: string,
    date: number
  ) => Promise<AppState>;

  clearPunchComments: (ActionParams: AppStateActionParams) => Promise<AppState>;
}

const commentActions: CommentActions = {
  getCommentsForIssue: async (
    { state }: AppStateActionParams,
    issueid: string
  ): Promise<AppState> => {
    const comments = await commentsForIssue(issueid);
    const commentMap = comments.reduce(
      (acc: CommentMap, c) => acc.set(c.id, c),
      Immutable.Map<string, Comment>()
    );
    return state().set('punchComments', commentMap);
  },

  addComment: async (
    { state }: AppStateActionParams,
    issueid: string,
    projectid: string,
    comment: string,
    date: number
  ): Promise<AppState> => {
    const newComment = await addComment(issueid, projectid, comment, date);
    return state().setIn(['punchComments', newComment.id], newComment);
  },

  deleteComment: async (
    { state }: AppStateActionParams,
    commentid: string,
    issueid: string,
    projectid: string,
    date: number
  ): Promise<AppState> => {
    const deletedComment = await deleteComment(
      commentid,
      issueid,
      projectid,
      date
    );
    return state().deleteIn(['punchComments', deletedComment.id]);
  },

  editComment: async (
    { state }: AppStateActionParams,
    issueid: string,
    projectid: string,
    commentid: string,
    comment: string,
    date: number
  ): Promise<AppState> => {
    const editedComment = await editComment(
      commentid,
      comment,
      issueid,
      projectid,
      date
    );
    return state().setIn(['punchComments', editedComment.id], editedComment);
  },

  clearPunchComments: async ({
    state,
  }: AppStateActionParams): Promise<AppState> => {
    return state().set(
      'punchComments',
      Immutable.OrderedMap<string, Comment>()
    );
  },
};

export default commentActions;
